import { Icon, IconProps } from '@chakra-ui/react'
import { FC } from 'react'

const NewChevronDown: FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 22 11" width="30px" fill={props.fill || 'alabaster'} {...props}>
      <path d="M.7 3.6 3.2.4l7.8 6 7.8-6 2.5 3.2-7.8 6c-1.4 1.1-3.5 1.1-4.9 0l-7.9-6z" />
    </Icon>
  )
}
export default NewChevronDown
